"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scapoli": {
    "6972a012": [{
      "hkey": "b9fa6202",
      "slug": "fontelavilla",
      "name": "Fontelavilla",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-la-villa": [{
      "hkey": "b9fa6202",
      "slug": "fontelavilla",
      "name": "Fontelavilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "17a84fa8": [{
      "hkey": "ab507507",
      "slug": "scapoli",
      "name": "Scapoli",
      "primary": true,
      "skipSearch": false
    }],
    "padulo": [{
      "hkey": "ab507507",
      "slug": "scapoli",
      "name": "Scapoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "22e78e22": [{
      "hkey": "ab507507",
      "slug": "scapoli",
      "name": "Scapoli",
      "primary": true,
      "skipSearch": false
    }],
    "vicenne": [{
      "hkey": "ab507507",
      "slug": "scapoli",
      "name": "Scapoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;